import { getCookie, setCookie } from "cookies-next";
import * as R from "ramda";
import { fullKey, Keys } from "./common";

export type PrivacyPolicyIsAcceptedValue = "False" | "True";
const PrivacyPolicyAcceptedMaxAge = 183 * 24 * 60 * 60; //in seconds

export function getPrivacyPolicyIsAccepted(): PrivacyPolicyIsAcceptedValue | null {
    const retVal = getCookie(fullKey(Keys.PrivacyPolicyAccepted))?.toString();
    return R.isNil(retVal) ? null : retVal as PrivacyPolicyIsAcceptedValue;
}

export function setPrivacyPolicyIsAccepted(value: PrivacyPolicyIsAcceptedValue): void {
    setCookie(fullKey(Keys.PrivacyPolicyAccepted), value, { maxAge: PrivacyPolicyAcceptedMaxAge });
}
